import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { isFirebaseConfigured } from './lib/firebase-config';
import { initI18n } from './lib/i18n';
import i18n from './lib/i18n';
import { ServiceUnavailablePage } from './pages/ServiceUnavailablePage';
import { SetupEnvPage } from './pages/SetupEnvPage';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element missing');

void initI18n().then(() => {
  const tree = isFirebaseConfigured() ? (
    <AuthProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </AuthProvider>
  ) : import.meta.env.DEV ? (
    <SetupEnvPage />
  ) : (
    <ServiceUnavailablePage />
  );

  createRoot(root).render(
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>{tree}</BrowserRouter>
      </I18nextProvider>
    </StrictMode>
  );
});
